module.exports = "/ui/main/images/arrow-next-no-bg.svg?2818ae79410e04225a29ee805affae44";